import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TextField,
  TableContainer,
  debounce,
  Grid,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useState } from "react";
import service from "../../Helpers/gifservices";
import { useLoading } from "../../../../providers/loadingProvider";
import { useNotify } from "../../../../providers/NotificationProvider";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    overflowX: "auto",
    maxHeight: 700,
    height: 650,
  },
  table: {
    // maxWidth: 1000,
    width: "100%",
  },
  tableCell: {
    fontWeight: 600,
    color: "#4B4B4B",
  },
  secoundTypography: {
    color: "#4B4B4B",
    fontWeight: 400,
    display: "inline",
    // fontSize:15
  },
  addButton: {
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    padding: 2,
  },
  addReviewerButton: {
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    width: 120,
  },
  iconButton: {
    padding: 2,
  },
  searchField: {
    margin: 5,
    marginLeft: 50,
    width: "50%",
    // padding: 2,
  },
  saveButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
    // float: "right",
    width: 120,
    marginTop: 10,
    marginBottom: 5,
    marginLeft: 6,
    marginRight: 6,
    borderRadius: 8,
  },
  cancelButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.red.hover,
    },
    color: theme.palette.gif.red.color,
    backgroundColor: theme.palette.gif.red.background,
    float: "right",
    width: 120,
    marginTop: 10,
    marginBottom: 5,
    borderRadius: 8,
    position: "absolute",
    right: 15,
    bottom: 5,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  paper: {
    position: "absolute",
    width: "90%",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #000",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    // margin:"0 auto 0 auto",
    top: `30%`,
    left: `18%`,
    transform: `translate(-15%, -25%)`,
    // maxHeight:700,
  },
}));

const ReviewerRow = (props) => {
  const { reviewer, addReviewer } = props;
  const [buttonClick, setButtonClick] = useState(false);
  const classes = useStyles();
  return (
    <TableRow>
      <TableCell>{reviewer.fullName}</TableCell>
      <TableCell>{reviewer.primaryEmail}</TableCell>
      <TableCell>{reviewer.websiteurl}</TableCell>
      <TableCell>{reviewer.keywords}</TableCell>
      <TableCell>
        <Button
          disableElevation
          variant="contained"
          size="small"
          className={classes.addReviewerButton}
          disabled={buttonClick}
          onClick={() => {
            addReviewer(reviewer.contactId, reviewer.primaryEmail);
            setButtonClick(true);
          }}
        >
          Add Reviewer
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default function SuggestedReviewer(props) {
  const classes = useStyles();
  const loading = useLoading();
  const notify = useNotify();
  const { proposalId, openCloseSuggestedReviewers } = props;
  const tableHeaders = [
    { label: "Name", size: "30%" },
    { label: "Email", size: "20%" },
    { label: "Website", size: "20%" },
    { label: "Keywords", size: "20%" },
    { label: "", size: "20%" },
  ];

  const [reviewers, setReviewers] = useState([]);

  const addReviewer = async (contactId, contactMail) => {
    const loadingId = loading.addLoading("Adding Reviewer");
    service.registerReferee({ email: contactMail });
    const createResult = await service.CreateProposalReferee({
      proposalId,
      contactId,
    });
    loading.removeLoading(loadingId);
    if (createResult.Error)
      notify.show(createResult.Error, { severity: "error" });
    else notify.show("Reviewer has been added");
  };

  const searchContacts = debounce(async (e) => {
    const searchWord = e.target.value;
    if (searchWord === "") return;
    const loadingId = loading.addLoading("Searching Reviewers");
    var reviewers = await service.GetContats(searchWord);
    reviewers.forEach((review) => {
      if (review.keywords?.length > 40) {
        review.keywords = review.keywords.slice(0, 40).concat("...");
      }
    });
    setReviewers(reviewers);
    notify.show(`Found ${reviewers.length} reviewers`);
    loading.removeLoading(loadingId);
  }, 1000);

  return (
    <Paper className={classes.paper}>
      <Paper elevation={0} className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <Typography className={classes.secoundTypography}>
              Suggested Reviewers
            </Typography>
            <TextField
              label="Search Reviewer"
              size="small"
              onChange={searchContacts}
              className={classes.searchField}
            ></TextField>
          </Grid>
          <Grid item sx={12}>
            <Typography fontSize={"0.8em"} fontWeight={"bold"}>
              ** Please type the suggested reviewer’s name or last name, and a
              list of options will be presented. If you do not find a reviewer,
              please email their details (including email address) to
              gif.admin@gif.org.il.
            </Typography>
          </Grid>
        </Grid>
        <TableContainer style={{ maxHeight: 560 }}>
          <Table stickyHeader className={classes.table} size="small">
            <TableHead>
              <TableRow>
                {tableHeaders.map((header) => (
                  <TableCell
                    className={classes.tableCell}
                    key={header.label}
                    align="left"
                    style={{ width: header.size }}
                  >
                    {header.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {reviewers.map((reviewer, index) => (
                <ReviewerRow
                  key={index}
                  reviewer={reviewer}
                  addReviewer={addReviewer}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Button
          disableElevation
          variant="contained"
          className={classes.cancelButton}
          onClick={() => openCloseSuggestedReviewers()}
        >
          Close
        </Button>
      </Paper>
    </Paper>
  );
}
